import React from "react";
import ArrowButton from "../utils/button/ArrowButton";
import FinalReadingModal from "../reading/FinalReadingModal";
import LandScapeModal from "../utils/modal/LandScapeModal";
import ErrorModal from "../utils/modal/ErrorModal";
import StoryImage from "../utils/StoryImage";
import StoryContentToggle from "../utils/StoryContentToggle";
import AudioBookCreationModal from "../audiobook/AudioBookCreationModal";
import Flipbook from "../flipbook/Flipbook";
import NovelFrame from "../flipbook/NovelFrame";
import { getLocalizedAssetPath } from "../../utils/getLocalizedLogo";

const SharingPC = ({
  bookData,
  story,
  index,
  setIndex,
  showFinalReadingModal,
  setShowFinalReadingModal,
  showErrorModal,
  setShowErrorModal,
  errorMessage,
  bgImage,
  contentText,
  speechState,
  imageSrc,
  isFlipping,
  setIsFlipping,
  isBookOpened,
  setIsBookOpened,
  showFlipbook,
  setShowFlipbook,
  showTitleOnCover,
  setShowTitleOnCover,
  showAudioModal,
  setShowAudioModal,
  handleButtonClick,
  handleSpeechState,
  handleAudioEnd,
  handleExit,
  audioRef,
  pageName,
  navigate,
  USER_ID,
}) => {
  return (
    <>
      {bookData?.style === "graphic_novel" ||
      bookData?.style === "그림 소설" ? (
        <NovelFrame
          isFlipping={isFlipping}
          showLogo={true}
          isOpened={showFlipbook}
        >
          {showFlipbook ? (
            <div className="flipbook-fade-in-wrapper">
              <Flipbook
                index={index}
                story={story}
                setStory={null} // logic should be in container if needed
                pageCount={story.length}
                setShowFinalModal={setShowFinalReadingModal}
                setIsFlipping={setIsFlipping}
                handleChangeBackground={null}
                setIndex={setIndex}
                isReadOnly={true}
                title={bookData?.title}
                cover={bookData?.bookcover}
              />
            </div>
          ) : (
            <div
              className={`book-shelf-cover ${isBookOpened ? "opened" : ""}`}
              onClick={() => {
                if (isBookOpened) return;
                setIsBookOpened(true);
                setTimeout(() => {
                  setShowFlipbook(true);
                  setIndex(0);
                }, 600);
              }}
            >
              <div className="result-book-container">
                <div className="result-book">
                  <div className="cover-content">
                    <div className="cover-title-toggle-tabs">
                      <button
                        className={`toggle-tab ${showTitleOnCover ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTitleOnCover(true);
                        }}
                      >
                        <img
                          src={
                            showTitleOnCover
                              ? getLocalizedAssetPath("/images/makingBranch/title-on.svg")
                              : getLocalizedAssetPath("/images/makingBranch/title-off.svg")
                          }
                          alt="제목 보기"
                          loading="lazy"
                          decoding="async"
                        />
                      </button>
                      <button
                        className={`toggle-tab ${!showTitleOnCover ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTitleOnCover(false);
                        }}
                      >
                        <img
                          src={
                            showTitleOnCover
                              ? getLocalizedAssetPath("/images/makingBranch/cover-off.svg")
                              : getLocalizedAssetPath("/images/makingBranch/cover-on.svg")
                          }
                          alt="표지 보기"
                          loading="lazy"
                          decoding="async"
                        />
                      </button>
                    </div>
                    <img
                      src={bookData?.bookcover}
                      alt="cover"
                      loading="lazy"
                      decoding="async"
                    />
                    <h2
                      className={`novel-title ${
                        !showTitleOnCover ? "hide" : ""
                      }`}
                    >
                      {bookData?.title}
                    </h2>
                  </div>
                </div>
                <figure className="result-book-left">
                  <img
                    src="/images/utils/modal/novelFinalModal/book-left.svg"
                    alt="spine"
                    loading="lazy"
                    decoding="async"
                  />
                </figure>
                <figure className="result-book-bottom">
                  <img
                    src="/images/utils/modal/novelFinalModal/book-bottom.svg"
                    alt="pages"
                    loading="lazy"
                    decoding="async"
                  />
                </figure>
              </div>
            </div>
          )}
        </NovelFrame>
      ) : (
        <section className="stories-section">
          <img
            src="/images/logo/magic4u-logo.svg"
            alt="로고"
            className="magic-logo"
            loading="lazy"
            decoding="async"
          />
          {showErrorModal && (
            <ErrorModal
              error_message={errorMessage}
              onClose={() => {
                setShowErrorModal(false);
                navigate("/storyland");
              }}
            />
          )}
          <StoryImage src={bgImage} alt="bg-img" />
          <StoryContentToggle
            showTitleOnCover={showTitleOnCover}
            setShowTitleOnCover={setShowTitleOnCover}
          />
          <div className="story-ui-layer">
            <ArrowButton
              onClick={() => handleButtonClick("left")}
              direction="left"
              className="story-btn prev-btn"
            />
            <ArrowButton
              onClick={() => handleButtonClick("right")}
              direction="right"
              className="story-btn next-btn"
            />
            <div
              className={`${
                typeof contentText === "string"
                  ? "story-contents-container title"
                  : "story-contents-container"
              } ${!showTitleOnCover ? "hide" : ""}`}
            >
              <ul
                className={
                  typeof contentText === "string"
                    ? "story-contents title"
                    : "story-contents"
                }
              >
                {typeof contentText === "string" ? (
                  <>
                    {contentText}
                    <div className="text-stroke">{contentText}</div>
                  </>
                ) : Array.isArray(contentText) ? (
                  <>
                    {contentText.map((sentence, i) => (
                      <li key={i} className="origin-text">
                        {sentence.trim()}
                        <div className="text-stroke">{sentence.trim()}</div>
                      </li>
                    ))}
                  </>
                ) : null}
              </ul>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleSpeechState();
              }}
              className="text-music-btn"
            >
              <img
                src={imageSrc}
                alt="음성 듣기 버튼"
                loading="lazy"
                decoding="async"
              />
            </button>
            <div className="numbering">{index + 1}</div>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd} />
        </section>
      )}
      {showFinalReadingModal && (
        <FinalReadingModal
          onBack={() => window.location.reload()}
          pageName={pageName}
          onClose={handleExit}
        />
      )}
      {showAudioModal && (
        <AudioBookCreationModal
          bookData={bookData}
          userID={USER_ID}
          onClose={() => setShowAudioModal(false)}
        />
      )}
      <LandScapeModal />
    </>
  );
};

export default SharingPC;
